import React, { FC } from 'react'
import { ModalButton } from '../../../../../../unansweredQuestions/styles'
import { TrainButtonState } from '../../../../../../unansweredQuestions/util/button'
import { ButtonProps } from './buttons-props'
import { SelectQuestionType } from './select-question-type'

export const RelevantQuestionButtons: FC<ButtonProps> = ({
  onCreateNewQuestion,
  onUpdateQuestion,
  buttonIsActive,
  setSelectedQuestionType,
  initQuestionType
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto', gap: '10px' }}>
      <SelectQuestionType questionCallback={setSelectedQuestionType} value={initQuestionType} />
      <ModalButton
        onClick={() => {
          onCreateNewQuestion()
        }}
        state={buttonIsActive ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
        Add New
      </ModalButton>
      <ModalButton
        onClick={() => {
          onUpdateQuestion()
        }}
        state={buttonIsActive ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
        Retrain
      </ModalButton>
    </div>
  )
}
